/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_How_EyebrowInputs */

const en_price_page_how_eyebrow = /** @type {(inputs: Price_Page_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you pay`)
};

const pl_price_page_how_eyebrow = /** @type {(inputs: Price_Page_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak płacisz`)
};

/**
* | output |
* | --- |
* | "How you pay" |
*
* @param {Price_Page_How_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_how_eyebrow = /** @type {((inputs?: Price_Page_How_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_How_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_how_eyebrow(inputs)
	return en_price_page_how_eyebrow(inputs)
});